import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import VueLazyload from '~/components/preload';
var lastUser = null;
// let lastDiffDate = -1
var filter = function filter(messages) {
  if (messages == null) {
    return [];
  }
  var newMessage = [];

  var dateObject = void 0;
  var lastDateUnitque = void 0;
  var lastUser = null;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var message = _step.value;

      dateObject = moment(message.date).toObject();
      var dateUnique = dateObject.years + '' + dateObject.months + '' + dateObject.date;
      if (lastDateUnitque !== dateUnique) {
        lastUser = null;
        lastDateUnitque = dateUnique;
        newMessage.push({
          id: lastDateUnitque,
          date: message.date,
          messageOfDate: []
        });
      }
      var lastMessage = newMessage[newMessage.length - 1];
      if (lastUser !== message.userID) {
        lastUser = message.userID;
        lastMessage.messageOfDate.push({
          userID: message.userID,
          roleID: message.roleID,
          userName: message.userName,
          msgOfUser: [message]
        });
      } else {
        var lenghOfUser = lastMessage.messageOfDate.length;
        var lastObjectOfUser = lastMessage.messageOfDate[lenghOfUser - 1];
        lastObjectOfUser.msgOfUser.push(message);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return newMessage;
};
var lastPerson = '';
export default {
  props: ['messages', 'persons'],
  data: function data(callback) {
    var newMessage = filter(this.messages);
    return { newMessage: newMessage, prevRowDate: null };
  },

  components: {
    VueLazyload: VueLazyload
  },
  watch: {
    messages: function messages() {
      this.newMessage = filter(this.messages);
      lastPerson = null;
    }
  },
  methods: {
    isMe: function isMe(userID) {
      return this.$store.state.authUser.userID === userID ? 'is-me' : 'is-other';
    },
    getPersonImage: function getPersonImage(userID) {
      if (this.persons === null || this.persons.lenght === 0) {
        return '';
      }
      var findPerson = this.persons.filter(function (o) {
        return o.id === userID;
      });
      if (findPerson === null || findPerson.length === 0) {
        return '';
      }

      return findPerson[0].avatar;
    },
    haveImage: function haveImage(userID) {
      if (this.persons === null || this.persons.lenght === 0) {
        return false;
      }
      var findPerson = this.persons.filter(function (o) {
        return o.id === userID;
      });
      if (findPerson === null || findPerson.length === 0) {
        return false;
      }
      if (findPerson[0].avatar === '') {
        return false;
      }
      return true;
    },
    isShow: function isShow(userID) {
      if (lastPerson !== userID) {
        lastPerson = userID;
        return true;
      }
      return false;
    },
    showTime: function showTime(date) {
      var messageDate = moment(date).format('HH:ss');
      return messageDate;
    },
    timeAgo: function timeAgo(date) {
      var now = moment();
      var dif = moment(date).diff(now, 'day') * -1;
      if (dif > 3) {
        return moment(date).format('DD/MM/YYYYY');
      } else if (dif > 0) {
        return moment(date).fromNow();
        // return '1234' + dif + ' ' + date
      } else {
        var objNow = now.toObject();
        var dateObj = moment(date).toObject();
        if (dateObj.date < objNow.date) {
          return moment(date).fromNow();
        }
        return 'today ';
      }
    },
    isUsedOldTempate: function isUsedOldTempate(index, message) {},
    resetUser: function resetUser() {
      lastUser = null;
    },
    displayUserName: function displayUserName(name) {
      if (name === null || name === undefined) {
        return '';
      }
      var v = name.split('@');
      return v[0];
    },
    isChangeUser: function isChangeUser(userID) {
      if (lastUser == null) {
        return true;
      }
      if (lastUser === userID) {
        return false;
      }
      return true;
    },
    setLastUser: function setLastUser(userID) {
      lastUser = userID;
    },
    displayIcon: function displayIcon(role) {
      if (role === null || role === undefined) {
        return '';
      }
      return role.substring(0, 1);
    },
    displayTime: function displayTime(time) {
      if (time === null || time === undefined) {
        return '';
      }
      return moment(time).startOf('minute').fromNow();
      // return time
      // let timeFormat = time.replace('T', ' ')
      // let v = timeFormat.split('.')
      // let trueDate = new Date(v[0]).getTime()
      // return timeAgo.format(trueDate)
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/chat.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/chat.vue
// module chunks = 0 1 2 3 4